export default {
  theme: 'light',
  indent: '4',
  mode: 'sublime',
  fontSize: 'normal',
  autoIndent: 'force' // [levels] 'force' / 'smart' / 'none'
};
